import React, {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPenToSquare, faTrashCan} from "@fortawesome/free-solid-svg-icons";
import {PlanForm} from "../Forms/PlanForm";
import {useNavigate} from "react-router-dom";
import Button from "../../../components/Common/Button";
import Dialogs from "../../../components/Common/Dialog";
import { PlanDetailsModel } from "../../../interfaces/plan.interface";
import { deletePlan, getPlans } from "./services/Plans.service";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import PlansTable from "./components/PlansTable";
import { TokenCookieManager } from "../../../utils/tokenCookies";
import MigrationManager from "../Forms/components/MigrationManager";

const Plans = () => {
    const [planId, setPlanId] = useState<string | null>(null);
    const [deleteLoader, setDeleteLoader] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [plans, setPlans] = useState<PlanDetailsModel[]>([]);
    const [planDetails, setPlanDetails] = useState<PlanDetailsModel | null>(null);
    const [loading] = useState(false);
    const [showMigration, setShowMigration] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!TokenCookieManager.hasToken()) {
            navigate("/admin");
        }
    });

    useEffect(() => {
        getPlans(setPlans, null);
    }, []);

    useEffect(() => {
        if (planDetails) setShowForm(true);
    }, [planDetails]);

    const handleDeletePlan = async () => {
        try {
            setDeleteLoader(true);
            const isDeleted = await deletePlan(planId!);
            if (isDeleted) {
                await getPlans(setPlans);
            }
            setOpenDialog(false);
        } finally {
            setDeleteLoader(false);
        }
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    return (
        <div className="p-0 md:p-0  bg-storytan">
            {showForm ? (
                <PlanForm
                    setShowForm={setShowForm}
                    planDetails={planDetails}
                    getPlans={getPlans}
                    setPlans={setPlans}
                    setPlanDetails={setPlanDetails}
                />
            ) : (
                <>
                    <div>
                        <div className="flex justify-between items-baseline flex-wrap gap-2 my-5">
                            <div className="flex gap-2">
                                <Button
                                    title="New Plan"
                                    className="w-40 flex justify-center gap-2 bg-storyblue text-white font-bold rounded-md text-base p-[0.4rem]"
                                    onClick={() => {
                                        setShowForm(true);
                                        setPlanDetails(null);
                                    }}
                                />
                                <Button
                                    title="Migration"
                                    className="w-40 flex justify-center gap-2 bg-green-600 text-white font-bold rounded-md text-base p-[0.4rem]"
                                    onClick={() => setShowMigration(!showMigration)}
                                />
                            </div>
                        </div>
                    </div>
                    
                    {showMigration && (
                        <div className="mb-6">
                            <MigrationManager 
                                onMigrationComplete={() => {
                                    getPlans(setPlans, null);
                                    setShowMigration(false);
                                }}
                            />
                        </div>
                    )}
                    {loading ? (
                        <LoadingSpinner/>
                    ) : (
                        <PlansTable
                            plans={plans}
                            setPlanDetails={setPlanDetails}
                            setOpenDialog={setOpenDialog}
                            setPlanId={setPlanId}
                        />
                    )}
                    <Dialogs
                        openDialog={openDialog}
                        handelClose={handleClose}
                        handelProcess={handleDeletePlan}
                        loader={deleteLoader}
                    />
                </>
            )}
        </div>
    );
};
export default Plans;
